<template>
  <ux-form ref="form" width="600px" :data="formData" :rules="rules" :colon="true">
    <p class="modal-tip">{{ $t('HT.subordinate.permission.configTip') }}</p>
    <div class="permission-tree-wrap">
      <el-tree
        ref="permissionTree"
        :data="treeData"
        :props="treeProps"
        node-key="key"
        show-checkbox
        :empty-text="$t('HT.subordinate.permission.emptyProducts')"
        @check="handleCheck"
      >
        <div class="tree-node" slot-scope="{ data }">
          <span class="node-name">{{ data.name }}</span>
          <el-tag v-if="data.type" size="mini" type="primary">{{ data.type }}</el-tag>
        </div>
      </el-tree>
    </div>
    <div class="quick-actions">
      <el-button type="text" :disabled="!treeData.length" @click="selectAll">{{
        $t('HT.deviceManage.checkAll')
      }}</el-button>
      <el-button type="text" :disabled="!selectedCount" @click="clearAll">{{
        $t('HT.subordinate.permission.clearAll')
      }}</el-button>
      <span>{{
        $t('HT.subordinate.permission.selectedCount', {
          selected: selectedCount,
          total: treeData.length
        })
      }}</span>
    </div>
  </ux-form>
</template>

<script>
export default {
  name: 'PermissionConfigModal',
  props: {
    // 当前正在配置权限的客户
    account: { type: Object, required: true },
    // 页面统一加载并缓存的权限产品列表
    products: { type: Array, default: () => [] }
  },
  data() {
    return {
      // 弹窗提交的产品 ID
      formData: {
        selectedIds: [],
        selectedNames: []
      },
      // 当前表单不在校验阶段拦截空权限，空权限由父页面二次确认
      rules: {},
      // el-tree 字段映射
      treeProps: {
        label: 'name'
      }
    };
  },
  computed: {
    // 将产品数据转换为 el-tree 单层数据
    treeData() {
      return this.products.map((product) => ({
        key: `product-${product.id}`,
        id: product.id,
        name: product.name,
        type: product.type
      }));
    },
    // 当前已选产品数量
    selectedCount() {
      return this.formData.selectedIds.length;
    }
  },
  watch: {
    // 产品列表加载或更新后回显账号已有权限
    products() {
      this.$nextTick(this.setDefaultChecked);
    }
  },
  mounted() {
    this.setDefaultChecked();
  },
  methods: {
    // 根据账号已有产品权限回显勾选状态
    setDefaultChecked() {
      if (!this.$refs.permissionTree) return;
      const selectedProductIds = this.account.productIds || [];
      const selectedProductNames = this.account.productNames || [];
      const checkedKeys = this.treeData
        .filter(
          (product) =>
            selectedProductIds.indexOf(product.id) > -1 ||
            selectedProductIds.indexOf(String(product.id)) > -1 ||
            selectedProductNames.indexOf(product.name) > -1
        )
        .map((product) => product.key);
      this.$refs.permissionTree.setCheckedKeys(checkedKeys);
      this.syncSelectedData();
    },
    // 勾选节点后同步弹窗提交数据
    handleCheck() {
      this.syncSelectedData();
    },
    // 收集已勾选的产品 ID
    syncSelectedData() {
      if (!this.$refs.permissionTree) return;
      const checkedNodes = this.$refs.permissionTree.getCheckedNodes(false, false);
      this.formData.selectedIds = checkedNodes.map((item) => item.id);
      this.formData.selectedNames = checkedNodes.map((item) => item.name);
    },
    // 选择全部产品
    selectAll() {
      this.$refs.permissionTree.setCheckedKeys(this.treeData.map((item) => item.key));
      this.syncSelectedData();
    },
    // 清空全部产品权限
    clearAll() {
      this.$refs.permissionTree.setCheckedKeys([]);
      this.syncSelectedData();
    }
  }
};
</script>

<style lang="scss" scoped>
.modal-tip { margin: 0 0 12px; color: #8c8c8c; font-size: 13px; }
.permission-tree-wrap { min-height: 180px; max-height: 380px; overflow-y: auto; padding: 8px 12px; border: 1px solid #f0f0f0; border-radius: 4px; }
.tree-node { display: flex; align-items: center; min-width: 0; width: 100%; padding-right: 12px; }
.node-name { margin-right: 8px; color: #303133; }
.quick-actions { display: flex; align-items: center; margin-top: 12px; color: #8c8c8c; font-size: 12px; .el-button + .el-button { margin-left: 14px; } span { margin-left: auto; } }
</style>
